import { gql } from "@apollo/client";

export const cancelOrder = gql`
  mutation cancelOrder($id: ID!) {
    cancelOrder(id: $id)
  }
`;